import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const MobileHeader = ({ title, onBack, children }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="md:hidden bg-gradient-to-r from-[#1B375B] to-[#659A9B] text-white shadow-lg">
      <div className="px-4 py-4">
        <div className="flex items-center justify-between">
          <button
            onClick={handleBack}
            className="p-2 hover:bg-white/10 rounded-full transition-colors"
          >
            <ArrowRight className="w-5 h-5 rotate-180" />
          </button>
          <h1 className="text-lg font-bold">{title}</h1>
          <div className="w-9" />
        </div>
        {children}
      </div>
    </div>
  );
};

export default MobileHeader;
